import { render } from "./ImageUpload.vue?vue&type=template&id=e0921fbe"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ImageUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0921fbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0921fbe', __exports__)) {
    console.log('reload')
    api.reload('e0921fbe', __exports__)
  }
  
  module.hot.accept("./ImageUpload.vue?vue&type=template&id=e0921fbe", () => {
    console.log('re-render')
    api.rerender('e0921fbe', render)
  })

}


export default __exports__